import React from 'react';
import TextField from '@mui/material/TextField';

interface TextConditionEditorProps {
  expression: string;
  onChange: (expression: string) => void;
  disabled?: boolean;
  readOnly?: boolean;
  error?: boolean;
  helperText?: string;
}

const TextConditionEditor: React.FC<TextConditionEditorProps> = ({
  expression,
  onChange,
  disabled = false,
  readOnly = false,
  error = false,
  helperText,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <TextField
      label="Condition Expression"
      multiline
      rows={4}
      fullWidth
      value={expression}
      onChange={handleChange}
      disabled={disabled}
      InputProps={{
        readOnly: readOnly,
      }}
      error={error}
      helperText={
        helperText ?? (error ? 'Invalid expression' : 'Enter the condition expression directly.')
      }
      variant="outlined"
      sx={{ mt: 2 }}
    />
  );
};

export default TextConditionEditor;
